import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";
import { FlagNames, Flags } from "./flags";

export const useFlags = (): Flags => useLDFlags();

export function useFlag<T extends FlagNames>(name: T): Flags[T] {
  const flags = useFlags();
  return flags[name];
}
